/// <amd-module name="Environments/EnvironmentRunDetails/Common/Constants" />

export const EnvironmentRunDetailsCommitsDataProviderContribution: string = "ms.vss-environments-web.environment-rundetails-commits-data-provider";
export const EnvironmentRunDetailsWorkitemsDataProviderContribution: string = "ms.vss-environments-web.environment-rundetails-workitems-data-provider";
export const EnvironemntJobHistoryStore: string = "environment-job-history-instance-id";
export const Identity_UnassignedUserIcon = "ms.vss-environments-web/environment-rundetails/Content/notassigned-user.svg";

export namespace PerformanceScenarios {
    export const EnvironmentRunDetailsCommitsPageLoad = "Environment.RunDetails.Commits.List.PageLoad";
    export const EnvironmentRunDetailsWorkitemsPageLoad = "Environment.RunDetails.Workitems.List.PageLoad";
}

